















import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, PullRefresh } from "vant";

import WeMixin from "@/components/weMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class DemoPullPage extends mixins(WeMixin) {
  private count: number = 0;
  private isLoading: boolean = false;

  protected onRefresh() {
    setTimeout(() => {
      this.$toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 500);
  }
}
